import { FC } from 'react'
import { SvgProps } from './svgProps'

const InstagramIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 17}
    height={height || 17}
    viewBox="0 0 17 17"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={color || '#FFF'} fillRule="nonzero">
        <g>
          <path
            d="M16.957 4.998c-.04-.903-.186-1.524-.395-2.062-.216-.571-.548-1.083-.984-1.508-.425-.432-.94-.767-1.504-.98-.542-.209-1.16-.355-2.063-.395C11.101.01 10.811 0 8.503 0S5.906.01 5 .05c-.903.04-1.525.186-2.063.395-.571.216-1.083.548-1.508.983-.432.425-.767.94-.98 1.504-.209.542-.355 1.16-.395 2.063C.01 5.905 0 6.194 0 8.502s.01 2.597.05 3.503c.04.904.186 1.525.395 2.063.216.57.551 1.082.983 1.507.425.432.94.768 1.505.98.541.21 1.16.355 2.063.395.906.04 1.196.05 3.504.05 2.309 0 2.598-.01 3.504-.05.904-.04 1.525-.186 2.063-.395 1.143-.442 2.046-1.345 2.488-2.487.21-.542.355-1.16.395-2.063.04-.906.05-1.195.05-3.503s-.003-2.597-.043-3.504zm-1.531 6.94c-.037.831-.176 1.28-.293 1.578-.285.741-.873 1.329-1.614 1.614-.299.117-.75.256-1.578.293-.897.04-1.166.05-3.434.05-2.269 0-2.541-.01-3.435-.05-.83-.037-1.279-.176-1.578-.293-.368-.136-.704-.352-.976-.634-.283-.276-.498-.608-.635-.976-.116-.3-.255-.75-.292-1.578-.04-.896-.05-1.165-.05-3.434 0-2.268.01-2.54.05-3.434.037-.83.176-1.278.292-1.577.137-.369.352-.704.638-.976.276-.283.608-.499.977-.635.299-.116.75-.255 1.577-.292.897-.04 1.166-.05 3.435-.05 2.272 0 2.541.01 3.435.05.83.037 1.278.176 1.577.292.369.136.704.352.977.635.282.275.498.607.634.976.117.299.256.75.293 1.577.04.897.05 1.166.05 3.434 0 2.269-.01 2.534-.05 3.43z"
            transform="translate(-749.000000, -89.000000) translate(749.000000, 89.000000)"
          />
          <path
            d="M8.503 4.135c-2.411 0-4.368 1.956-4.368 4.367 0 2.41 1.957 4.367 4.368 4.367 2.412 0 4.368-1.956 4.368-4.367s-1.956-4.367-4.368-4.367zm0 7.2c-1.564 0-2.833-1.27-2.833-2.833 0-1.565 1.269-2.833 2.833-2.833 1.565 0 2.834 1.268 2.834 2.833 0 1.564-1.27 2.833-2.834 2.833zM14.064 3.962c0 .563-.457 1.02-1.02 1.02s-1.02-.457-1.02-1.02.457-1.02 1.02-1.02 1.02.457 1.02 1.02z"
            transform="translate(-749.000000, -89.000000) translate(749.000000, 89.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default InstagramIcon
